// extracted by mini-css-extract-plugin
export default {"card":"styles_card__kAPtj","close":"styles_close__st3Bz"};